import colors from './colors';
const forms = {
    inputShadow: 'none',
    inputPadding: '0.688rem 1rem 0.813rem 1rem',
    fontWeight: 400,
    inputHeight: '3rem',
    inputBorder: `1px solid ${colors.grayL10}`,
    inputBorderRadius: '0.375rem',
    iconSize: '1.625rem',
    iconSpacing: '0.625rem',
    inputErrorOutlineColor: `${colors.red}`,
    inputDisabledBackgroundColor: `${colors.grayL40}`,
    switchColorOn: `${colors.blueD10}`,
    switchColorOff: `${colors.grayD10}`,
    switchCheckMarkDisplay: 'inline-block',
};
export default forms;
//# sourceMappingURL=forms.js.map